import Slider from 'react-slick';
import { ArticlePreview } from 'interfaces/content/articles/Articles';
import ArticleCard from 'components/Globals/ArticleCard';
import { ArticleCardFieldsVariant } from 'components/Globals/ArticleCard/articleCardHelpers';
import * as S from './CarouselStyles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export interface CarouselProps {
  articles: ArticlePreview[];
  dataVariant?: ArticleCardFieldsVariant;
}

const Carousel = ({ articles, dataVariant }: CarouselProps) => {
  const settings = {
    className: '',
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
  };
  return (
    <S.Wrapper>
      <Slider {...settings}>
        {articles.length > 0 &&
          articles.map((article) => (
            <ArticleCard
              key={article.title}
              layoutVariant='hero'
              dataVariant={dataVariant}
              article={article}
              eyebrowType='red'
              trackingData={{
                contentPlacementCD: 'hero',
                eventAction: 'title click',
                eventCategory: 'navigation',
                eventLabel: article.title,
              }}
              titleFontFamily='saol'
              titleSize={{ default: 'level2', mdMin: 'level1' }}
              className='article-card'
              priority
            />
          ))}
      </Slider>
    </S.Wrapper>
  );
};

export default Carousel;
